import { connect } from 'react-redux'
import {
  setAvailableFilters,
  setSavedFilters,
  setSelectedFilters,
  loadAvailableFilters,
  updateUserFilters,
  types,
} from '../../../../actions/reports/projects_report'

import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.LOAD_AVAILABLE_FILTERS])

export default connect(
  (state: any) => ({
    availableFilters: state?.reports?.projectsReport?.availableFilters || [],
    savedFilters: state?.reports?.projectsReport?.savedFilters || [],
    selectedFilters: state?.reports?.projectsReport?.selectedFilters || [],
    isFetching: loadingSelector(state),
  }),
  {
    setAvailableFilters,
    setSavedFilters,
    setSelectedFilters,
    loadAvailableFilters,
    updateUserFilters,
  }
)
